import { useEffect } from "react";

type HappyFoxParams = {
  isEnabled?: boolean;
};

const useHappyFox = ({ isEnabled = true }: HappyFoxParams = {}) => {
  useEffect(() => {
    if (!isEnabled) return undefined;

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: HappyFox chat installation script
    window.HFCHAT_CONFIG = {
      EMBED_TOKEN: process.env.NEXT_PUBLIC_HAPPYFOX_EMBED_TOKEN,
      ASSETS_URL: "https://widget.happyfoxchat.com/v2/visitor",
    };

    const iframe = document.getElementById("hfc-frame");
    iframe?.style.setProperty("display", "block");

    if (!document.getElementById("hfchat-script")) {
      const script = document.createElement("script");
      script.id = "hfchat-script";
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore: HappyFox chat installation script
      script.src = `${window.HFCHAT_CONFIG.ASSETS_URL}/js/widget-loader.js`;
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      iframe?.style.setProperty("display", "none", "important");
    };
  }, [isEnabled]);
};

export default useHappyFox;
